import { configureStore } from '@reduxjs/toolkit';
import themetoggle from './GlobalState/ThemeToggle';
import isMobile from './GlobalState/isMobile';
import isTablet from './GlobalState/isTablet';

export const store = configureStore({
  reducer: {
    themeSlice: themetoggle,
    mobileSlice: isMobile,
    tabletSlice: isTablet,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
